export default __webpack_public_path__ + "static/media/nr.d85a0ce8.svg";